(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[335],{

/***/ 9679:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact",
      function () {
        return __webpack_require__(6161);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6161:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages_contact; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/components/Layout/index.ts + 11 modules
var Layout = __webpack_require__(8077);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/esm/text.js
var esm_text = __webpack_require__(4115);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/esm/flex.js
var flex = __webpack_require__(4096);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/esm/box.js
var box = __webpack_require__(8017);
// EXTERNAL MODULE: ./src/components/Image/index.ts + 1 modules
var Image = __webpack_require__(8331);
;// CONCATENATED MODULE: ./public/whatsapp.png
/* harmony default export */ var whatsapp = ({"src":"/_next/static/media/whatsapp.a373847c.png","height":82,"width":75,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAYAAAA1BOUGAAAA80lEQVR4nAHoABf/ATzUbgAbAw4WqfnXeQD+8ioAAQvWWAcsh+T+8uoBR9VzIbn8579iBykfLgghANj54wCY+NLhRwQaQQEA0FO+dQs8QTsNLvq/8s8EOQwr/ND22waI9MC/ARzSY/t6EEUDJQgeAaPtugCi+M0ApBZm/2btrf0BFNJi+oAPRQTP990BURE8AOj67QD9//7/f/C4/AEAzke6phduRf0A/vrn+uwEMAwn/LPvxQaT9sq7AQDOSB5sDEG9BwEFJBIDDQDR+eEAqvre3EoEG0MBAM9PAADssRIAE0Z0AAACLAACDtVgCCuL3/zu7tSgZ6jXhnPDAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./public/linkedin.png
/* harmony default export */ var linkedin = ({"src":"/_next/static/media/linkedin.0e4d48d8.png","height":99,"width":99,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA10lEQVR42jWMO6rCUBBAp3qli8iGXIHFK9/z01i5CS2sFCtR0EorsbEQxEZBEMRGBPFHENQkNya5453xjuKBYThnYEAgojIzn+1sjaGt9bM0EOLEpNniBxEbY/gLEXGiKQ1BiAUJ4+kG3YtPt3tISYIoTT2eBfAU/osMR2vT7M64Uptwf7A00rwA/8BXmBfp9BZYbUxouTpQszv/fsjD5Y6Zt4Qxe/6Do1izUhELcgPIHFPuFdsa2dVP3sWadna7trXg95iCD/UfyB0cKNopnRzI7p13A4AX6dLGdDedobQAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./public/contact/rajiv-avatar.png
/* harmony default export */ var rajiv_avatar = ({"src":"/_next/static/media/rajiv-avatar.b3d38266.png","height":87,"width":87,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA/0lEQVR42iWNP0vDQByG71vc4CA4uCgOjuLg4iD4BVRwESeX0iEupYIK6tDhiojUP4vD2YqLbipizKDJVnTRQ+hm4iAkpjR3jffqL33H93ngYTQAvHF8KpfXKlHr6ib66XYlfQAG0PcDNTk6gev1FShRQttzkf1CIe9xEqT76GGYMf0myja+rFn3YEd/JymIkRAFvo8xxuxFaRGvwsHHSdWaNAaxQvgMQ2wuzNvz1Tm8H20jbNZsbjQsCcYYSerTw72uTA/Z9u5/5uVZ05f3+0WCJ2lPOVt1lKdG4DmzCG7v0IlzBSScFZvZ4OPVptzfO/zq1JeiVuNMMpFxJjL2B88DtmTi/772AAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./public/contact/rana-avatar.png
/* harmony default export */ var rana_avatar = ({"src":"/_next/static/media/rana-avatar.e21e2706.png","height":87,"width":87,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA8klEQVR42i2Pu0oDURRF71/Mt/gX/oMIFjaCYGFURA2I+GgSi6jBB9zKIIqvwiKohZLxQdRmMuqAILfKZJLM5DJzzg4nya42a+1mKwkAJ/h40+7OrPk8WDPtvx8tbCg7oZMCXuP8CN2TBYSH84jdKgB4SavpKAY0JTHquznrFha5Xlrlp71Nm/USiJOBoSjEf3mZg/0V+OUNvBaXmDoRxCnKMgMA0dczB8U5+IU8fu+vWRgRGQVAp0SoVR/t+9Y0v2zPMGxsZZClqR48OKucemPjU3DvavCP13FzcYWG/+2JU6NI0fnSrbmsPJiJyZweMdUHqCG70crAJUYAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./public/contact/bg-circle.svg
/* harmony default export */ var bg_circle = ({"src":"/_next/static/media/bg-circle.0c0ee79f.svg","height":1330,"width":1213});
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./node_modules/next/node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__(8520);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(2175);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(4231);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/input/dist/esm/input.js
var input = __webpack_require__(1962);
;// CONCATENATED MODULE: ./src/components/TextInput/TextInput.tsx


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {
        };
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {
    };
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {
    };
    var target = {
    };
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var TextInput = function(_param) /*#__PURE__*/ {
    var label = _param.label, rest = _objectWithoutProperties(_param, [
        "label"
    ]);
    return (0,jsx_runtime.jsxs)(box/* Box */.xu, {
        children: [
            label && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                fontSize: [
                    "14px",
                    null,
                    null,
                    null,
                    null,
                    "18px"
                ],
                lineHeight: [
                    "8.09px",
                    null,
                    null,
                    null,
                    null,
                    "23px"
                ],
                fontWeight: "300",
                color: "gray",
                mb: [
                    "13px",
                    null,
                    null,
                    null,
                    null,
                    "8px"
                ],
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, _objectSpread({
            }, rest))
        ]
    });
};
/* harmony default export */ var TextInput_TextInput = (TextInput);

;// CONCATENATED MODULE: ./src/components/TextInput/index.ts


// EXTERNAL MODULE: ./node_modules/@chakra-ui/textarea/dist/esm/textarea.js
var esm_textarea = __webpack_require__(17);
;// CONCATENATED MODULE: ./src/components/Textarea/Textarea.tsx


function Textarea_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Textarea_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {
        };
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Textarea_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Textarea_objectWithoutProperties(source, excluded) {
    if (source == null) return {
    };
    var target = Textarea_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Textarea_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {
    };
    var target = {
    };
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Textarea = function(_param) /*#__PURE__*/ {
    var label = _param.label, rest = Textarea_objectWithoutProperties(_param, [
        "label"
    ]);
    return (0,jsx_runtime.jsxs)(box/* Box */.xu, {
        children: [
            label && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                fontSize: [
                    "14px",
                    null,
                    null,
                    null,
                    null,
                    "18px"
                ],
                lineHeight: [
                    "8.09px",
                    null,
                    null,
                    null,
                    null,
                    "23px"
                ],
                fontWeight: "300",
                color: "gray",
                mb: [
                    "13px",
                    null,
                    null,
                    null,
                    null,
                    "8px"
                ],
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_textarea/* Textarea */.g, Textarea_objectSpread({
            }, rest))
        ]
    });
};
/* harmony default export */ var Textarea_Textarea = (Textarea);

;// CONCATENATED MODULE: ./src/components/Textarea/index.ts


// EXTERNAL MODULE: ./src/components/Button/index.ts + 1 modules
var Button = __webpack_require__(599);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ./src/services/axios.ts

var AxiosInstanceToken = function() {
    var instance = axios_default().create({
        baseURL: "https://is-101digital-sandbox.101digital.io/oauth2",
        auth: {
            username: "zN1hhUUvZvVMZB9cT8geTf8aKW0a",
            password: "ITsE2GBM43FMvyDHS_fpWZD2QZsa"
        },
        headers: {
            "content-type": "application/x-www-form-urlencoded"
        }
    });
    return instance;
};
var AxiosInstanceBase = function() {
    var instance = axios_default().create({
        baseURL: "https://api-wso2-101digital-sandbox.101digital.io",
        headers: {
            "content-type": "application/json"
        }
    });
    return instance;
};


;// CONCATENATED MODULE: ./src/services/contact/index.ts


function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var Contact = function Contact() {
    "use strict";
    _classCallCheck(this, Contact);
    this.getToken = _asyncToGenerator(runtime_default().mark(function _callee() {
        var response;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return AxiosInstanceToken().post("/token", "grant_type=client_credentials&scope=PRODUCTION", {
                        params: {
                            tenantDomain: "carbon.super"
                        }
                    });
                case 2:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response.data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    this.sendMail = _asyncToGenerator(runtime_default().mark(function _callee(materials) {
        var body, response;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    body = materials.body;
                    body.append("appId", "101D");
                    body.append("type", "Contact");
                    _ctx.next = 5;
                    return AxiosInstanceBase().post("/customer-support-service/1.0.0/requests", body, {
                        headers: {
                            authorization: "Bearer ".concat(materials.token)
                        }
                    });
                case 5:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response.data);
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
};
var ContactInstance = new Contact();
/* harmony default export */ var contact = (ContactInstance);

;// CONCATENATED MODULE: ./src/containers/FormContact/FormContact.tsx










function FormContact_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function FormContact_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                FormContact_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                FormContact_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var initialValues = {
    name: "",
    email: "",
    message: ""
};
var fieldNames = {
    name: "name",
    email: "email",
    message: "message"
};
var FormContact = function(param) {
    var refSuccessfullyMessage = param.refSuccessfullyMessage, setSentEmail = param.setSentEmail, refErrorMessage = param.refErrorMessage, setError = param.setError;
    var ref = (0,react.useState)(false), sendingEmail = ref[0], setSendingEmail = ref[1];
    var handleSubmitEmailApi = FormContact_asyncToGenerator(runtime_default().mark(function _callee(values) {
        var responseGetToken, token, bodySendMailFormData;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    setSendingEmail(true);
                    _ctx.prev = 1;
                    _ctx.next = 4;
                    return contact.getToken();
                case 4:
                    responseGetToken = _ctx.sent;
                    token = responseGetToken.access_token;
                    if (!token) {
                        _ctx.next = 16;
                        break;
                    }
                    bodySendMailFormData = new FormData();
                    bodySendMailFormData.append(fieldNames.name, values.name);
                    bodySendMailFormData.append(fieldNames.email, values.email);
                    bodySendMailFormData.append(fieldNames.message, values.message);
                    _ctx.next = 13;
                    return contact.sendMail({
                        body: bodySendMailFormData,
                        token: token
                    });
                case 13:
                    setSendingEmail(false);
                    setSentEmail(true);
                    formik.resetForm();
                case 16:
                    _ctx.next = 23;
                    break;
                case 18:
                    _ctx.prev = 18;
                    _ctx.t0 = _ctx["catch"](1);
                    setSendingEmail(false);
                    setError(true);
                    formik.resetForm();
                case 23:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                18
            ]
        ]);
    }));
    var formik = (0,formik_esm/* useFormik */.TA)({
        initialValues: initialValues,
        validationSchema: es/* object */.Ry().shape({
            name: es/* string */.Z_().trim().required("Please provide your full name."),
            email: es/* string */.Z_().email("Invalid email address.").required("Please provide your email address."),
            message: es/* string */.Z_().trim().required("Please provide more information on how we can help you.")
        }),
        onSubmit: handleSubmitEmailApi
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        onSubmit: formik.handleSubmit,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(box/* Box */.xu, {
                mb: "34px",
                position: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput_TextInput, {
                        padding: [
                            "0 8px",
                            null,
                            null,
                            "0 16px"
                        ],
                        label: "Name*",
                        name: fieldNames.name,
                        value: formik.values.name,
                        onChange: formik.handleChange,
                        onBlur: formik.handleBlur,
                        border: formik.touched.name && formik.errors.name ? "1px solid #ff0000" : "none"
                    }),
                    formik.touched.name && formik.errors.name && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                        position: "absolute",
                        color: "#ff0000",
                        mt: "4px",
                        fontSize: [
                            "14px",
                            null,
                            null,
                            "16px"
                        ],
                        children: formik.errors.name
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(box/* Box */.xu, {
                mb: "34px",
                position: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput_TextInput, {
                        padding: [
                            "0 8px",
                            null,
                            null,
                            "0 16px"
                        ],
                        label: "Business Email*",
                        name: fieldNames.email,
                        value: formik.values.email,
                        onChange: formik.handleChange,
                        onBlur: formik.handleBlur,
                        border: formik.touched.email && formik.errors.email ? "1px solid #ff0000" : "none"
                    }),
                    formik.touched.email && formik.errors.email && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                        position: "absolute",
                        color: "#ff0000",
                        mt: "4px",
                        fontSize: [
                            "14px",
                            null,
                            null,
                            "16px"
                        ],
                        children: formik.errors.email
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(box/* Box */.xu, {
                mb: "34px",
                position: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Textarea_Textarea, {
                        minHeight: [
                            "182px",
                            null,
                            null,
                            null,
                            null,
                            "215px"
                        ],
                        padding: [
                            "8px",
                            null,
                            null,
                            "8px 16px"
                        ],
                        label: "What we can help you with?*",
                        name: fieldNames.message,
                        value: formik.values.message,
                        onChange: formik.handleChange,
                        onBlur: formik.handleBlur,
                        border: formik.touched.message && formik.errors.message ? "1px solid #ff0000" : "none"
                    }),
                    formik.touched.message && formik.errors.message && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                        position: "absolute",
                        color: "#ff0000",
                        mt: "4px",
                        fontSize: [
                            "14px",
                            null,
                            null,
                            "16px"
                        ],
                        children: formik.errors.message
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                mt: [
                    "37px",
                    null,
                    null,
                    null,
                    null,
                    "0px"
                ],
                w: "100%",
                fontSize: [
                    "12px",
                    null,
                    null,
                    null,
                    null,
                    "16px"
                ],
                isLoading: sendingEmail,
                type: "submit",
                _hover: {
                    bg: "primary"
                },
                children: "Send"
            })
        ]
    }));
};
/* harmony default export */ var FormContact_FormContact = (FormContact);

;// CONCATENATED MODULE: ./src/containers/FormContact/index.ts


// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/esm/button.js + 7 modules
var esm_button = __webpack_require__(4056);
;// CONCATENATED MODULE: ./src/containers/FormContact/FormContactNotification.tsx


var FormContactNotification = function(param) {
    var state = param.state, setState = param.setState, ref = param.ref, message = param.message;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(box/* Box */.xu, {
        display: state ? "block" : "none",
        p: [
            "51px 25px",
            null,
            null,
            null,
            null,
            "90px 40px 62px"
        ],
        border: "1px solid #D2D2F5",
        boxShadow: "0px 5px 20px rgba(0, 0, 0, 0.25)",
        borderRadius: "10px",
        bgColor: "#ffffff",
        mb: [
            "99px",
            null,
            null,
            null,
            null,
            "0px"
        ],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                as: "h2",
                textStyle: "h2",
                fontSize: [
                    "18px",
                    null,
                    null,
                    null,
                    null,
                    "21px"
                ],
                fontWeight: "300",
                mb: "40px",
                ref: ref,
                lineHeight: "1.4",
                whiteSpace: "pre-wrap",
                children: message
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_button/* Button */.z, {
                w: "100%",
                minH: "46px !important",
                height: "46px !important",
                onClick: function() {
                    return setState(false);
                },
                children: "Close"
            })
        ]
    }));
};
/* harmony default export */ var FormContact_FormContactNotification = (FormContactNotification);

;// CONCATENATED MODULE: ./src/pages/contact/index.tsx













var contact_Contact = function() {
    var ref = (0,react.useState)(false), sentEmail = ref[0], setSentEmail = ref[1];
    var ref1 = (0,react.useState)(false), error = ref1[0], setError = ref1[1];
    var refSuccessfullyMessage = (0,react.useRef)(null);
    var refErrorMessage = (0,react.useRef)(null);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(head["default"], {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: "101Digital | Contact"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                as: "h1",
                textStyle: "h1",
                fontSize: [
                    "36px",
                    null,
                    null,
                    null,
                    null,
                    "72px"
                ],
                lineHeight: "85px",
                textAlign: [
                    "center",
                    null,
                    null,
                    null,
                    null,
                    "left"
                ],
                mb: [
                    "0px",
                    null,
                    null,
                    null,
                    null,
                    "19px"
                ],
                mt: [
                    "25px",
                    null,
                    null,
                    null,
                    null,
                    "46px"
                ],
                display: [
                    "block",
                    null,
                    null,
                    null,
                    null,
                    "none"
                ],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                    children: "Let's Talk!"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                textStyle: "paragraphHighlighted",
                textAlign: [
                    "center",
                    null,
                    null,
                    null,
                    null,
                    "left"
                ],
                px: [
                    "49px",
                    null,
                    null,
                    null,
                    null,
                    "0px"
                ],
                mb: [
                    "92px",
                    null,
                    null,
                    null,
                    null,
                    "84px"
                ],
                fontWeight: "300",
                display: [
                    "block",
                    null,
                    null,
                    null,
                    null,
                    "none"
                ],
                children: "Time to build a great digital product and take it to market! Submit your details, and we will get in touch."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
                p: [
                    0,
                    null,
                    null,
                    null,
                    null,
                    "97px 2% 231px 6%",
                    "97px 4% 231px 12%",
                    null,
                    "97px 8% 231px 16%",
                    "97px 13.8% 231px 19.375%", 
                ],
                mt: [
                    0,
                    null,
                    null,
                    null,
                    null,
                    "52px"
                ],
                pos: "relative",
                flexDir: [
                    "column-reverse",
                    null,
                    null,
                    null,
                    null,
                    "row"
                ],
                w: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(box/* Box */.xu, {
                        pos: "absolute",
                        top: 0,
                        right: [
                            "-117px",
                            null,
                            null,
                            "0"
                        ],
                        zIndex: "-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            src: bg_circle,
                            alt: "101d"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(box/* Box */.xu, {
                        pr: [
                            0,
                            null,
                            null,
                            null,
                            null,
                            "66px"
                        ],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                                as: "h1",
                                textStyle: "h1",
                                fontSize: [
                                    "36px",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "72px"
                                ],
                                lineHeight: "85px",
                                textAlign: [
                                    "center",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "left"
                                ],
                                mb: [
                                    "0px",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "19px"
                                ],
                                mt: [
                                    "72.26px",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "46px"
                                ],
                                display: [
                                    "none",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "block"
                                ],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                                    children: "Let's Talk!"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                                textStyle: "paragraphHighlighted",
                                textAlign: [
                                    "center",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "left"
                                ],
                                px: [
                                    "49px",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "0px"
                                ],
                                mb: [
                                    "92px",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "84px"
                                ],
                                fontWeight: "300",
                                display: [
                                    "none",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "block"
                                ],
                                children: "Time to build a great digital product and take it to market! Submit your details, and we will get in touch."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
                                alignItems: "center",
                                mb: [
                                    "23.21px",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "14px"
                                ],
                                justify: [
                                    "center",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "flex-start"
                                ],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(box/* Box */.xu, {
                                        w: [
                                            "31.87px",
                                            null,
                                            null,
                                            null,
                                            null,
                                            "auto"
                                        ],
                                        h: [
                                            "34.72px",
                                            null,
                                            null,
                                            null,
                                            null,
                                            "auto"
                                        ],
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                            src: whatsapp,
                                            alt: "101D"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                                        as: "h2",
                                        textStyle: "h2",
                                        fontSize: [
                                            "18px",
                                            null,
                                            null,
                                            null,
                                            null,
                                            "36px"
                                        ],
                                        lineHeight: [
                                            "36.12px",
                                            null,
                                            null,
                                            null,
                                            null,
                                            "85px"
                                        ],
                                        ml: [
                                            "9.77px",
                                            null,
                                            null,
                                            null,
                                            null,
                                            "23px"
                                        ],
                                        children: "Connect on Whatsapp"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_text/* Text */.x, {
                                textStyle: "paragraph",
                                mb: [
                                    "49.01px",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "22.67px"
                                ],
                                whiteSpace: "pre-line",
                                fontSize: [
                                    "14px",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "22px"
                                ],
                                color: "primary",
                                textAlign: [
                                    "center",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "left"
                                ],
                                fontWeight: 300,
                                lineHeight: [
                                    "17.21px",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "40.5px"
                                ],
                                children: [
                                    "You can also speak to our founders directly. ",
                                    "\n",
                                    "That's how approachable we are!"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
                                flexDir: [
                                    "column",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "row"
                                ],
                                mb: [
                                    "88.65px",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "0px"
                                ],
                                justify: [
                                    "center",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "flex-start"
                                ],
                                alignItems: [
                                    "center",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "flex-start"
                                ],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
                                        alignItems: "center",
                                        mb: [
                                            "30.89px",
                                            null,
                                            null,
                                            null,
                                            null,
                                            "0px"
                                        ],
                                        onClick: function() {
                                            return window.open("https://wa.me/6583390399", "_blank");
                                        },
                                        cursor: "pointer",
                                        mr: [
                                            "0px",
                                            null,
                                            null,
                                            null,
                                            null,
                                            "77.67px"
                                        ],
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                src: rana_avatar,
                                                alt: "101D"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                                                textStyle: "paragraph",
                                                ml: [
                                                    "30.72px",
                                                    null,
                                                    null,
                                                    null,
                                                    null,
                                                    "36px"
                                                ],
                                                color: "primary",
                                                children: "Rana"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
                                        alignItems: "center",
                                        onClick: function() {
                                            return window.open("https://wa.me/6583390388", "_blank");
                                        },
                                        cursor: "pointer",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                src: rajiv_avatar,
                                                alt: "101D"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                                                textStyle: "paragraph",
                                                ml: [
                                                    "30.72px",
                                                    null,
                                                    null,
                                                    null,
                                                    null,
                                                    "36px"
                                                ],
                                                color: "primary",
                                                children: "Rajiv"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(box/* Box */.xu, {
                        px: [
                            "20px",
                            null,
                            null,
                            null,
                            null,
                            "0px"
                        ],
                        width: "100%",
                        maxW: "641px",
                        m: "auto",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormContact_FormContactNotification, {
                                ref: refSuccessfullyMessage,
                                state: sentEmail,
                                setState: setSentEmail,
                                message: "Thank you for your inquiry!\nWe will get back to you as soon as possible."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormContact_FormContactNotification, {
                                ref: refErrorMessage,
                                state: error,
                                setState: setError,
                                message: "There was an error trying to send your message\nPlease try again later."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(box/* Box */.xu, {
                                width: "100%",
                                p: [
                                    "51px 25px",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "64px 40px"
                                ],
                                border: "1px solid #D2D2F5",
                                boxShadow: "0px 5px 20px rgba(0, 0, 0, 0.25)",
                                borderRadius: "10px",
                                bgColor: "#ffffff",
                                mb: [
                                    "99px",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "0px"
                                ],
                                display: sentEmail || error ? "none" : "block",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormContact_FormContact, {
                                    refSuccessfullyMessage: refSuccessfullyMessage,
                                    refErrorMessage: refErrorMessage,
                                    setError: setError,
                                    setSentEmail: setSentEmail
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
                flexDir: "column",
                alignItems: "center",
                w: "100%",
                bgColor: "primary",
                bgImage: "url('/circuit-board-blue-small.png')",
                p: [
                    "46.85px 0px 36px",
                    null,
                    null,
                    null,
                    null,
                    "87px 0px 67px"
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_text/* Text */.x, {
                        color: "white",
                        as: "h2",
                        textStyle: "h2",
                        lineHeight: [
                            "20px",
                            null,
                            null,
                            null,
                            null,
                            "54px"
                        ],
                        fontSize: [
                            "14px",
                            null,
                            null,
                            null,
                            null,
                            "36px"
                        ],
                        mb: [
                            "36px",
                            null,
                            null,
                            null,
                            null,
                            "64px"
                        ],
                        textAlign: "center",
                        maxW: [
                            "255px",
                            null,
                            null,
                            null,
                            null,
                            "unset"
                        ],
                        whiteSpace: [
                            "normal",
                            null,
                            null,
                            null,
                            null,
                            "pre-line"
                        ],
                        children: [
                            "Follow us to know the latest FinTech developments, product ",
                            "\n",
                            " ",
                            "roadmaps, and customer success stories."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(box/* Box */.xu, {
                        w: [
                            "54px",
                            null,
                            null,
                            null,
                            null,
                            "83px"
                        ],
                        h: [
                            "54px",
                            null,
                            null,
                            null,
                            null,
                            "83px"
                        ],
                        cursor: "pointer",
                        onClick: function() {
                            return window.open("https://www.linkedin.com/company/101digital/", "_blank");
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            src: linkedin,
                            alt: "101D"
                        })
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var pages_contact = (contact_Contact);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [425,557,77,774,888,179], function() { return __webpack_exec__(9679); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);